import PropTypes from 'prop-types';
import React from 'react';

import { ButtonStyled } from './Button.style';

const Button = React.forwardRef(
  (
    {
      children,
      variant = 'contained',
      color = 'secondary',
      rounded = false,
      'data-test-subject': dataTestSubject = null,
      disableElevation,
      uppercase = false,
      ...props
    },
    ref
  ) => {
    return (
      <ButtonStyled
        ref={ref}
        data-test-subject={
          dataTestSubject ||
          (typeof children === 'string' ? `${children}-button` : null)
        }
        variant={variant}
        color={color}
        rounded={rounded}
        disableElevation={disableElevation}
        uppercase={uppercase}
        {...props}>
        {children}
      </ButtonStyled>
    );
  }
);

Button.displayName = 'Button';

Button.propTypes = {
  /** Displayed content. */
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.element,
  ]).isRequired,
  /** Cypress hook. */
  'data-test-subject': PropTypes.string,
  variant: PropTypes.oneOfType([
    PropTypes.oneOf(['contained', 'outlined', 'text']),
    PropTypes.string,
  ]),
  rounded: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large', 'extraLarge']),
  uppercase: PropTypes.bool,
};

export default Button;
